/**
 * @generated SignedSource<<3ab8a15004c0db968f33710bba3ba93f>>
 * @relayHash 5139de600d5e4e49615c1742fae27659
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf06d566e2dc098c2d1b04753fbbaf4518876e1c9388b9f50bc5e9633929f813

import type { ConcreteRequest } from 'relay-runtime';
export type useAnalyticsByLineNotifyUsersOnFirstViewMutation$variables = {
  input: string;
};
export type useAnalyticsByLineNotifyUsersOnFirstViewMutation$data = {
  readonly notifyUsersOnFirstView: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useAnalyticsByLineNotifyUsersOnFirstViewMutation = {
  response: useAnalyticsByLineNotifyUsersOnFirstViewMutation$data;
  variables: useAnalyticsByLineNotifyUsersOnFirstViewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "input"
      }
    ],
    "concreteType": "NotificationResponsePayload",
    "kind": "LinkedField",
    "name": "notifyUsersOnFirstView",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAnalyticsByLineNotifyUsersOnFirstViewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAnalyticsByLineNotifyUsersOnFirstViewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5139de600d5e4e49615c1742fae27659",
    "id": "bf06d566e2dc098c2d1b04753fbbaf4518876e1c9388b9f50bc5e9633929f813",
    "metadata": {},
    "name": "useAnalyticsByLineNotifyUsersOnFirstViewMutation",
    "operationKind": "mutation",
    "text": "mutation useAnalyticsByLineNotifyUsersOnFirstViewMutation($input:ID!){notifyUsersOnFirstView(contentId:$input){success,errors{message}}}"
  }
};
})();

(node as any).hash = "68415d9fbcae3b85bb99318f819f12d6";

export default node;
